// extracted by mini-css-extract-plugin
export default {"table":"styles_table__D4mPl","roundTrip":"styles_roundTrip__ombFh"};